import { ldapPlatform, googlePlatform, microsoftPlatform } from './envSettings'

const platformId = {
  LDAP: ldapPlatform(),
  GOOGLE: googlePlatform(),
  MICROSOFT: microsoftPlatform(),
}

export default platformId